import { Id } from '@typings';

export const getHomepageSlug = (state: Store) => state.cms.homepage.slug;
export const getIsHomepageLoading = (state: Store) => state.cms.homepage.isLoading;

export const getHomepageByBuyerId =
  (id: Id) =>
  (state: Store): Nullable<string> | undefined =>
    state.cms.homepage.homepageByBuyer[id];
